__turbopack_context__.v({
  "active": "style-module-scss-module__FjNDwG__active",
  "breadcrumbs": "style-module-scss-module__FjNDwG__breadcrumbs",
  "grid": "style-module-scss-module__FjNDwG__grid",
  "side-panel-grid": "style-module-scss-module__FjNDwG__side-panel-grid",
});
